export const normalizeValue = (value, minValue = 0, maxValue = 100) => {
  if (value <= minValue) {
    return minValue;
  }

  if (value >= maxValue) {
    return maxValue;
  }

  return value;
};

export const validateEmail = email => {
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};

export const launchToast = toast => {
  this.showToast(toast, {
    position: "bottom-center",
    duration: 5000
  });
};

export const isPhoneNumber = str => {
  if (!str) {
    return false;
  }
  str = str.trim();
  if (str.length !== 10) {
    return false;
  }
  str = str.replace(/^0+/, "") || "0";
  var n = Math.floor(Number(str));
  return n !== Infinity && String(n) === str && n >= 0;
};

export const removeWhiteSpace = str => {
  if (str) return str.replace(/ /g, "");
  return null;
};

export const formatPhoneNumber = str => {
  if (isPhoneNumber(str)) {
    let newStr =
      str.slice(0, 2) +
      " " +
      str.slice(2, 4) +
      " " +
      str.slice(4, 6) +
      " " +
      str.slice(6, 8) +
      " " +
      str.slice(8, 10);
    return newStr;
  }
  return str;
};
